module.exports = __webpack_public_path__ + "static/img/feature_5.53cc969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/feature_5.png
// module id = OwzO
// module chunks = 0